<template>
  <div>
    <el-dialog
      ref="addEditDialog"
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      class="h410_dialog abow_dialog"
      width="1100px"
      :before-close="modalClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
    >
      <el-form
        ref="dialogAddEditForm"
        :model="dialogAddEditForm"
        :rules="dialogAddEditFormRules"
        class="add-edit-view-form"
        @submit.native.prevent
      >
        <div class="modal-box">
          <h3 class="modal-title">
            基础信息
          </h3>
          <div class="modal-row-box">
            <el-row :gutter="10">
              <el-col :span="6">
                <el-form-item
                  label="微信群名称"
                  prop="name"
                >
                  <el-input
                    v-model="dialogAddEditForm.name"
                    maxlength="64"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="省区"
                  prop="provinceId"
                >
                  <el-select
                    v-model="dialogAddEditForm.provinceId"
                    filterable
                    clearable
                    placeholder="请选择省区"
                    style="width:100%"
                  >
                    <el-option
                      v-for="item in provinceOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="覆盖市场"
                  prop="market"
                >
                  <el-input
                    v-model="dialogAddEditForm.market"
                    maxlength="128"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="6">
                <el-form-item
                  label="群主"
                  prop="groupOwner"
                >
                  <el-input
                    v-model="dialogAddEditForm.groupOwner"
                    maxlength="32"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="群创建人"
                  prop="createBy"
                >
                  <el-input
                    v-model="dialogAddEditForm.createBy"
                    maxlength="32"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="群人数"
                  prop="memberNumber"
                >
                  <el-input-number
                    v-model="dialogAddEditForm.memberNumber"
                    :min="1"
                    :max="500"
                    :controls="false"
                    style="width: 100%;"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="状态"
                  required
                >
                  <el-radio-group v-model="dialogAddEditForm.status">
                    <el-radio :label="1">
                      正常
                    </el-radio>
                    <el-radio :label="2">
                      已解散
                    </el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
        <div class="modal-box">
          <h3 class="modal-title">
            备注信息
          </h3>
          <div class="modal-row-box">
            <el-row :gutter="10">
              <el-col :span="24">
                <el-form-item prop="remark">
                  <el-input
                    v-model="dialogAddEditForm.remark"
                    type="textarea"
                    placeholder="备注"
                    maxlength="250"
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-form>

      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          v-if="eventType!=='view'"
          type="primary"
          @click="handleSave"
        >
          保存
        </el-button>
        <el-button @click="modalClose">
          关闭
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// dialog拖拽Mixin
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 区域API
import { listAreaApi } from '@/api/v2/area';
// 微信群管理API
import { viewWeChatGroupApi, saveWeChatGroupApi } from '@/api/v2/weChatGroup'

export default {
  components: {},
  mixins: [dialogDragMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    eventType: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dataId: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      dialogAddEditForm: {},
      dialogAddEditFormRules: {
        provinceId: [{ required: true, message: '请选择省区', trigger: 'change' }],
        name: [
          { required: true, message: '请输入微信群名称', trigger: 'blur' },
          { max: 64, message: '最多允许输入64个字符', trigger: 'blur' }
        ],
        groupOwner: [{ max: 32, message: '最多允许输入32个字符', trigger: 'blur' }],
        createBy: [{ max: 32, message: '最多允许输入32个字符', trigger: 'blur' }],
        market: [
          { required: true, message: '请输入微信群覆盖业务市场', trigger: 'blur' },
          { max: 128, message: '最多允许输入128个字符', trigger: 'blur' }
        ],
        remark: [{ max: 250, message: '最多允许输入250个字符', trigger: 'blur' }]
      },
      provinceOptions: [],
    }
  },
  watch: {
    dialogVisible (val) {
      if (val) {
        let _this = this;

        _this.dialogAddEditForm = {
          provinceId: '',
          name: '',
          groupOwner: '',
          createBy: '',
          market: '',
          memberNumber: 0,
          status: 1,
          remark: '',
        }

        _this.loadProvinceData()
        if (_this.eventType !== 'add') {
          _this.loadWeChatGroupData()
        }

        _this.$nextTick(() => {
          _this.$refs.dialogAddEditForm.clearValidate()
        })
      }
    }
  },
  methods: {
    // 加载数据
    loadWeChatGroupData () {
      let _this = this;
      viewWeChatGroupApi({ id: _this.dataId }).then((response) => {
        const { data } = response
        for (let key in _this.dialogAddEditForm) {
          _this.dialogAddEditForm[key] = data[key]
        }
        _this.dialogAddEditForm.id = data.id
      })
    },
    // 获取省区下拉数据
    loadProvinceData () {
      let _this = this;
      _this.provinceOptions = [];
      listAreaApi({ parentId: 1, isUserArea: 1 }).then((response) => {
        const { data } = response;
        data.forEach(item => {
          _this.provinceOptions.push({ label: item.name, value: item.id })
        })
      })
    },
    // 新增|修改保存
    handleSave () {
      let _this = this;
      _this.$refs.dialogAddEditForm.validate(valid => {
        if (valid) {
          _this.$confirm(
            (_this.eventType === 'add' ? '是否确定新增' : '是否确定修改') + '微信群', '系统提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }
          ).then(async () => {
            saveWeChatGroupApi(_this.dialogAddEditForm).then(() => {
              _this.$message({ message: '保存成功', type: 'success' })
              _this.$emit('reloadData')
              _this.modalClose()
            }).catch(() => { })
          }).catch(() => { })
        }
      })
    },
    modalClose () {
      let _this = this;
      _this.$emit('update:dialogVisible', false)
      _this.$refs.dialogAddEditForm.clearValidate()
    },
  }
}
</script>
<style lang="scss"  scoped>
</style>
